import { call, put, select, takeLatest } from 'redux-saga/effects';
import {
  GET_SALES_REPORT_DATETIME_DATA,
  GET_SALES_REPORT_GROUP_DATA,
  GET_SALES_REPORT_INDIVIDUAL_DATA,
  GET_SALES_REPORT_SUMMARY_DATA,
  CHECK_AGENT_IS_LEAF_NODE,
  GET_SALES_REPORT_POLICY_DATA,
  GET_SALES_REPORT_PIE_CHART_DATA,
} from './constants.js';
import {
  setSalesReportDateTimeDataAction,
  setSalesReportPieChartDataAction,
  setSalesReportPolicyAction,
  setSalesReportSummaryDataAction,
  setSalesReportTableDataAction,
  fetchTeamPolicyListStartAction,
  fetchTeamPolicyListSuccessAction,
} from './actions.js';
import {
  getSalesReportPolicyService,
  getSalesReportDatetimeListService,
  getSalesReportGroupListService,
  getSalesReportIndividualListService,
  getSalesReportSummaryService,
  getAgentIsLeafNodeService,
  getSalesReportPieChartService,
} from '@services/salesReport/salesReport.js';
import { loadingRequest, loadingSuccess } from '@stores/global/actions.js';
import { delay } from '@helpers/utils/utils.js';
import { GlobalModal } from '@components/molecules/PopupModal/GlobalModal.jsx';
import { ErrorLevelConfig } from '@core/configureStore/ErrorLevelConfig.js';
import { selectRoles } from '@stores/auth/selectors.js';
import { isAcbLeaderOrLbs } from '@helpers/roleUtils.js';

export function* getSalesReportDatetimeData({ payload }) {
  try {
    yield put(loadingRequest());
    const response = yield call(getSalesReportDatetimeListService, payload);
    yield put(loadingSuccess());

    yield put(setSalesReportDateTimeDataAction(response.data));
  } catch (err) {
    yield put(loadingSuccess());
    console.error(err);
    GlobalModal.openOnce({
      title: 'Error',
      message: ErrorLevelConfig.SAGA.FETCH_ERROR,
      onOk: () => {
        // Do nothing
      },
    });
  }
}

export function* getAgentIsLeafNodeData({ payload, callback }) {
  try {
    yield put(loadingRequest());
    const response = yield call(getAgentIsLeafNodeService, payload);
    yield put(loadingSuccess());
    if (callback) callback(response);
  } catch (err) {
    yield put(loadingSuccess());
    console.error(err);
    GlobalModal.openOnce({
      title: 'Error',
      message: ErrorLevelConfig.SAGA.FETCH_ERROR,
      onOk: () => {
        // Do nothing
      },
    });
  }
}

export function* getSalesReportGroupData({ payload }) {
  try {
    yield put(loadingRequest());
    yield delay(1000);
    const response = yield call(getSalesReportGroupListService, payload);
    yield put(loadingSuccess());

    yield put(setSalesReportTableDataAction(response));
  } catch (err) {
    yield put(loadingSuccess());
    console.error(err);
    GlobalModal.openOnce({
      title: 'Error',
      message: ErrorLevelConfig.SAGA.FETCH_ERROR,
      onOk: () => {
        // Do nothing
      },
    });
  }
}

export function* getSalesReportIndividualData({ payload }) {
  try {
    yield put(loadingRequest());
    yield delay(1000);
    const response = yield call(getSalesReportIndividualListService, payload);
    yield put(loadingSuccess());

    yield put(setSalesReportTableDataAction(response));
  } catch (err) {
    yield put(loadingSuccess());
    console.error(err);
    GlobalModal.openOnce({
      title: 'Error',
      message: ErrorLevelConfig.SAGA.FETCH_ERROR,
      onOk: () => {
        // Do nothing
      },
    });
  }
}

export function* getSalesReportTableData(action) {
  if (action.type === GET_SALES_REPORT_GROUP_DATA) {
    yield* getSalesReportGroupData(action);
  } else {
    yield* getSalesReportIndividualData(action);
  }
}

export function* getSalesReportSummaryData({ payload }) {
  try {
    yield put(loadingRequest());
    const response = yield call(getSalesReportSummaryService, payload);
    yield put(loadingSuccess());

    yield put(setSalesReportSummaryDataAction(response));
  } catch (err) {
    yield put(loadingSuccess());
    console.error(err);
    GlobalModal.openOnce({
      title: 'Error',
      message: ErrorLevelConfig.SAGA.FETCH_ERROR,
      onOk: () => {
        // Do nothing
      },
    });
  }
}

export function* getSalesReportPieChartData({ payload }) {
  try {
    yield put(loadingRequest());
    const profileRoles = yield select(selectRoles);
    const response = yield call(getSalesReportPieChartService, {
      ...payload,
      isAcbLeaderOrLbs: isAcbLeaderOrLbs(profileRoles),
    });
    yield put(loadingSuccess());

    yield put(setSalesReportPieChartDataAction(response));
  } catch (err) {
    yield put(loadingSuccess());
    console.error(err);
    GlobalModal.openOnce({
      title: 'Error',
      message: ErrorLevelConfig.SAGA.FETCH_ERROR,
      onOk: () => {
        // Do nothing
      },
    });
  }
}

export function* getSalesReportPolicyData({ payload }) {
  try {
    yield put(fetchTeamPolicyListStartAction());
    const response = yield call(getSalesReportPolicyService, payload);
    yield put(fetchTeamPolicyListSuccessAction());

    yield put(setSalesReportPolicyAction(response));
  } catch (err) {
    yield put(fetchTeamPolicyListSuccessAction());
    console.error(err);
    GlobalModal.openOnce({
      title: 'Error',
      message: ErrorLevelConfig.SAGA.FETCH_ERROR,
      onOk: () => {
        // Do nothing
      },
    });
  }
}

export default function* salesReportSaga() {
  yield takeLatest(GET_SALES_REPORT_DATETIME_DATA, getSalesReportDatetimeData);
  yield takeLatest(
    [GET_SALES_REPORT_GROUP_DATA, GET_SALES_REPORT_INDIVIDUAL_DATA],
    getSalesReportTableData,
  );
  yield takeLatest(GET_SALES_REPORT_SUMMARY_DATA, getSalesReportSummaryData);
  yield takeLatest(GET_SALES_REPORT_PIE_CHART_DATA, getSalesReportPieChartData);
  yield takeLatest(GET_SALES_REPORT_POLICY_DATA, getSalesReportPolicyData);
  yield takeLatest(CHECK_AGENT_IS_LEAF_NODE, getAgentIsLeafNodeData);
}
